import { Helmet } from "react-helmet"
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

function Thirdtheme({ get_data }) {
    const imgBase = "https://admin.reliep.com/services/";
    let imgsArr = [];
    const other = get_data?.other_images;
    if (Array.isArray(other)) { imgsArr = other } else if (typeof other === 'string') { try { imgsArr = JSON.parse(other) } catch(e) { imgsArr = [] } }
    const gallery = imgsArr.map(n => (n && n.startsWith('http')) ? n : (n ? imgBase + n : null)).filter(Boolean);
    const mosaicImgs = gallery.length ? gallery : [
        "https://images.unsplash.com/photo-1557804506-669a67965ba0?q=80&w=800&auto=format&fit=crop",
        "https://images.unsplash.com/photo-1529333166437-7750a6dd5a70?q=80&w=800&auto=format&fit=crop",
        "https://images.unsplash.com/photo-1524253482453-3fed8d2fe12b?q=80&w=800&auto=format&fit=crop",
        "https://images.unsplash.com/photo-1519389950473-47ba0277781c?q=80&w=800&auto=format&fit=crop"
    ];
    const ps = Array.isArray(get_data?.product_services) ? get_data.product_services : [];
    const clean = (s) => (typeof s === 'string' ? s.replace(/[`\s]/g, '').replace(/^"|"$/g, '') : s);
    const cardImage = (item) => {
        const f = clean(item?.featured_image);
        if (f) return f;
        const oi = item?.other_images;
        let arr = [];
        if (Array.isArray(oi)) arr = oi; else if (typeof oi === 'string') { try { arr = JSON.parse(oi) } catch(e) { arr = [] } }
        return arr[0] || null;
    };
    const phone = get_data?.mobile || get_data?.contact_no || get_data?.phone || null;
    const reviews = Array.isArray(get_data?.review_ratings) ? get_data.review_ratings : [];
    const stars = (n) => {
        const s = Math.max(0, Math.min(5, parseInt(n)));
        return '★★★★★'.slice(0, s).padEnd(5, '☆');
    };
    const initials = (name) => {
        if (!name || typeof name !== 'string') return 'US';
        const compact = name.replace(/\s+/g, '');
        return compact.slice(0,2).toUpperCase() || 'US';
    };
    return (
        <>
            <Helmet>
                <title>{(get_data?.service_name || get_data?.first_name || "Partner Store") + " - Partner Store"}</title>
                <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
                <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&family=Playfair+Display:ital,wght@1,600&display=swap" rel="stylesheet" />
            </Helmet>
            <style>{`
*{box-sizing:border-box;margin:0;padding:0}
body{font-family:Poppins,system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;background:#f6f8fc;color:#0e1a2b;line-height:1.55}
:root{--text:#0e1a2b;--muted:#6b7280;--accent:#e13b3b;--primary:#5b5cf7;--primary2:#7d7df9;--card:#fff;--shadow:0 20px 40px rgba(15,27,42,.08)}
.container{max-width:1140px;margin:0 auto;padding:0 24px}
header{position:relative;overflow:hidden;background:linear-gradient(180deg,#f2f6ff 0%,#f7f8fc 100%)}
.nav{display:flex;align-items:center;justify-content:space-between;padding:18px 0}
.brand{display:flex;align-items:center;gap:10px;font-weight:700}
.brand-mark{width:26px;height:18px;border-radius:999px;background:conic-gradient(from 180deg,#ff6b6b,#ff3b3b,#e60026);transform:skewX(-15deg)}
.nav ul{list-style:none;display:flex;gap:26px;color:var(--muted)}
.nav a{text-decoration:none;color:inherit}
.cta{display:inline-flex;align-items:center;gap:8px;background:var(--primary);color:#fff;border:none;border-radius:999px;padding:12px 20px;font-weight:600;box-shadow:0 10px 24px rgba(91,92,247,.35)}
.hero{display:grid;grid-template-columns:1.2fr 1fr;gap:40px;align-items:center;padding:30px 0 70px}
.hero h1{font-size:42px;font-weight:700}
.accent{font-family:"Playfair Display",serif;font-style:italic;color:var(--accent)}
.hero p{color:var(--muted);margin-top:12px}
.hero .list{display:grid;grid-template-columns:repeat(3,1fr);gap:14px;margin-top:18px}
.chip{display:flex;align-items:center;gap:10px;background:#fff;border:1px solid #eef2f7;border-radius:999px;padding:10px 14px;box-shadow:var(--shadow)}
.chip i{width:24px;height:24px;border-radius:50%;display:grid;place-items:center;background:#22c55e;color:#fff;font-size:14px}
.hero .actions{margin-top:24px;display:flex;gap:12px}
.secondary{background:#fff;color:var(--text);border:1px solid #e5e7eb}
.visual{position:relative;height:460px}
.circle{position:absolute;right:-40px;top:-40px;width:520px;height:520px;border-radius:50%;background:radial-gradient(520px 520px at 70% 30%,#7d7df9,#5b5cf7 60%,#4c51f9 100%);filter:drop-shadow(0 30px 60px rgba(75,81,249,.35))}
.portrait{position:absolute;right:40px;bottom:40px;width:320px;height:420px;border-radius:24px;background:#fff;display:grid;place-items:center;box-shadow:var(--shadow)}
.portrait img{width:92%;height:92%;object-fit:cover;border-radius:18px}
.shape-deco{position:absolute;right:80px;top:26px;width:36px;height:36px;border-radius:50%;background:#ffd84d}
.shape-deco2{position:absolute;right:12px;bottom:12px;width:26px;height:26px;border-radius:8px;background:#5b5cf7}
.section{padding:80px 0}
.section h2{font-size:32px}
.lead{color:var(--muted);max-width:780px;margin-top:10px}
.grid-hero{display:grid;grid-template-columns:1fr 1fr;gap:24px;align-items:center;margin-top:26px}
.mosaic{display:grid;grid-template-columns:1fr 1fr;gap:10px}
.mosaic img{width:100%;height:180px;object-fit:cover;border-radius:12px;box-shadow:var(--shadow)}
.info-card{background:#fff;border-radius:16px;padding:24px;box-shadow:var(--shadow);border:1px solid #eef2f7}
.info-card h3{font-size:24px}
.info-card .meta{display:flex;gap:12px;color:var(--muted);margin-top:10px}
.features{margin-top:12px;display:grid;grid-template-columns:repeat(3,1fr);gap:16px}
.feature{background:#fff;border-radius:14px;padding:16px;border:1px solid #eef2f7;box-shadow:var(--shadow)}
.feature b{display:block}
.services{margin-top:30px;display:grid;grid-template-columns:repeat(3,1fr);gap:18px}
.service{background:#fff;border-radius:16px;padding:18px;border:1px solid #edf2f7;box-shadow:var(--shadow)}
.service .icon{width:42px;height:42px;border-radius:12px;background:#5b5cf7;color:#fff;display:grid;place-items:center;font-weight:700}
.service h4{margin-top:10px}
.pricing{display:grid;grid-template-columns:1fr 1fr;gap:18px;margin-top:22px}
.price-card{background:#fff;border-radius:18px;padding:18px;box-shadow:var(--shadow)}
.price-card img{width:100%;height:220px;object-fit:cover;border-radius:12px}
.testimonial{margin-top:40px;background:linear-gradient(#fff,#fff) padding-box,linear-gradient(135deg,#5b5cf7,#7d7df9) border-box;border-radius:18px;padding:24px;box-shadow:var(--shadow);border:1px solid transparent}
.t-head{display:flex;align-items:center;gap:14px}
.avatar{width:54px;height:54px;border-radius:50%;object-fit:cover}
.quote{margin-top:10px;color:var(--muted)}
.slider{margin-top:14px;height:6px;background:#e6ecff;border-radius:999px;position:relative}
.slider::after{content:"";position:absolute;left:20%;right:40%;top:0;height:100%;background:#5b5cf7;border-radius:999px}
.t-wrap{position:relative;margin-top:20px}
.t-slider{overflow:hidden;border-radius:16px}
.t-track{display:flex;gap:0;transition:transform .45s ease;animation:tAuto 15s infinite}
.t-card{flex:0 0 100%;padding:24px;background:#fff;position:relative;border-radius:16px}
.t-card::before{content:"\u201C";position:absolute;top:-8px;left:-2px;font-family:serif;font-size:64px;color:#e6ecff;line-height:1}
.t-name{font-weight:600}
.t-role{color:var(--muted);font-size:13px}
.stars{margin-top:8px;color:#f59e0b}
input[name="t"]{display:none}
#t-1:checked ~ .t-slider .t-track{transform:translateX(0%)}
#t-2:checked ~ .t-slider .t-track{transform:translateX(-100%)}
#t-3:checked ~ .t-slider .t-track{transform:translateX(-200%)}
.t-controls{display:flex;justify-content:center;gap:10px;margin-top:16px}
.t-controls label{width:10px;height:10px;border-radius:50%;background:#cbd5e1;cursor:pointer;border:2px solid #e6ecff;transition:transform .2s ease, background .2s ease}
.t-controls label:hover{transform:scale(1.2)}
#t-1:checked ~ .t-controls label[for="t-1"],#t-2:checked ~ .t-controls label[for="t-2"],#t-3:checked ~ .t-controls label[for="t-3"]{background:#5b5cf7}
@keyframes tAuto{0%{transform:translateX(0%)}33%{transform:translateX(-100%)}66%{transform:translateX(-200%)}100%{transform:translateX(0%)}}
#t-1:checked ~ .t-slider .t-track,#t-2:checked ~ .t-slider .t-track,#t-3:checked ~ .t-slider .t-track{animation:none}
.t-arrows{position:absolute;inset:0;pointer-events:none}
.t-arrows .arrow{position:absolute;left:0;right:0;top:50%;transform:translateY(-50%);display:none;justify-content:space-between;align-items:center;padding:0 6px}
.t-arrows .btn{pointer-events:auto;width:38px;height:38px;border-radius:50%;background:#fff;border:1px solid #e6ecff;box-shadow:var(--shadow);display:grid;place-items:center;color:#5b5cf7;font-weight:700}
#t-1:checked ~ .t-arrows .a-1,#t-2:checked ~ .t-arrows .a-2,#t-3:checked ~ .t-arrows .a-3{display:flex}
.stats{position:relative;margin-top:34px;background:linear-gradient(135deg,#f9fafe 0%,#eef3ff 100%);border-radius:22px;padding:28px;box-shadow:var(--shadow);display:grid;grid-template-columns:repeat(4,1fr);gap:18px}
.stat{background:#fff;border-radius:18px;padding:18px;text-align:center;box-shadow:var(--shadow);transition:transform .2s ease, box-shadow .2s ease}
.stat:hover{transform:translateY(-3px);box-shadow:0 30px 50px rgba(15,27,42,.12)}
.m-icon{width:44px;height:44px;border-radius:14px;margin:0 auto 10px;display:grid;place-items:center;color:#fff;font-weight:700}
.m-icon.blue{background:linear-gradient(135deg,#5b5cf7,#7d7df9)}
.m-icon.yellow{background:linear-gradient(135deg,#f59e0b,#fbbf24)}
.m-icon.pink{background:linear-gradient(135deg,#ec4899,#f472b6)}
.m-icon.green{background:linear-gradient(135deg,#10b981,#34d399)}
.stat b{font-size:26px}
.stat div{color:#6b7280;margin-top:4px}
.m-shape.one{position:absolute;left:18px;top:18px;width:12px;height:12px;border-radius:50%;background:#ffd84d}
.m-shape.two{position:absolute;right:18px;bottom:18px;width:18px;height:18px;border-radius:8px;background:#5b5cf7}
.m-shape.three{position:absolute;left:30%;bottom:-8px;width:0;height:0;border-left:8px solid transparent;border-right:8px solid transparent;border-top:12px solid #ec4899}
.contact{margin-top:40px}
.form-wrap{background:#fff;border-radius:18px;padding:24px;box-shadow:var(--shadow)}
.form{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-top:14px}
.form label{display:block;font-size:13px;color:var(--muted);margin-bottom:6px}
.form input,.form select,.form textarea{width:100%;border:1px solid #e5e7eb;border-radius:10px;padding:12px;font:inherit}
.form textarea{min-height:120px;resize:vertical}
.form .row{grid-column:1 / -1;display:grid;grid-template-columns:1fr 1fr;gap:12px}
.form .actions{grid-column:1 / -1;margin-top:12px;display:flex;gap:12px}
.cta-band{margin-top:40px;background:linear-gradient(90deg,#5b5cf7,#7d7df9);color:#fff;border-radius:20px;padding:28px;box-shadow:var(--shadow);display:flex;justify-content:space-between;align-items:center}
footer{margin-top:40px;background:#fff}
.footer-top{display:grid;grid-template-columns:1fr 1fr 1fr;gap:20px;padding:24px 0;border-top:1px solid #e5e7eb}
.newsletter{display:flex;gap:10px}
.newsletter input{flex:1;border:1px solid #e5e7eb;border-radius:999px;padding:10px 14px}
.footer-bottom{display:flex;justify-content:space-between;align-items:center;padding:16px 0;border-top:1px solid #eef2f7;color:var(--muted)}
@media (max-width:992px){.hero{grid-template-columns:1fr}.grid-hero{grid-template-columns:1fr}.services{grid-template-columns:1fr 1fr}.pricing{grid-template-columns:1fr}.form{grid-template-columns:1fr}.stats{grid-template-columns:1fr 1fr}.footer-top{grid-template-columns:1fr 1fr}}
@media (max-width:640px){.services{grid-template-columns:1fr}.stats{grid-template-columns:1fr}.footer-top{grid-template-columns:1fr}}

.s-card{background:#fff;border:1px solid #edf2f7;border-radius:18px;box-shadow:var(--shadow);padding:16px;transition:transform .2s ease, box-shadow .2s ease}
.s-card:hover{transform:translateY(-4px);box-shadow:0 30px 50px rgba(15,27,42,.12)}
.s-thumb{position:relative;height:180px;border-radius:14px;overflow:hidden;margin-top:8px}
.s-thumb img{width:100%;height:100%;object-fit:cover}
.s-badge{position:absolute;left:12px;top:12px;background:linear-gradient(135deg,#5b5cf7,#7d7df9);color:#fff;border-radius:999px;padding:6px 10px;font-weight:700;box-shadow:0 10px 20px rgba(91,92,247,.25)}
.s-icon{width:42px;height:42px;border-radius:12px;background:linear-gradient(135deg,#5b5cf7,#7d7df9);color:#fff;display:grid;place-items:center;font-weight:700}
.s-title{margin-top:8px;font-weight:700}
.s-desc{color:var(--muted);margin-top:6px}
.s-actions{display:flex;gap:10px;margin-top:10px}
.owl-theme .owl-nav [class*='owl-']{background:#fff;border:1px solid #e5e7eb;color:#5b5cf7;border-radius:999px;padding:6px 12px;box-shadow:var(--shadow)}
.owl-theme .owl-nav [class*='owl-']:hover{background:#5b5cf7;color:#fff}
            `}</style>

            <header>
                <div className="container nav">
                    <div className="brand">
                        <img src="https://reliep.com/services-img/images/logo.png" alt="logo" style={{width:"100px"}}></img>
                    </div>
                    <ul>
                        <li><a href="#">Home</a></li>
                        <li><a href="#services">Services</a></li>
                        <li><a href="#contact">Contact</a></li>
                    </ul>
                    <button className="cta">Get Started</button>
                </div>
                <div className="container hero">
                    <div>
                        <h1>Professional <span className="accent">{get_data?.service_name || get_data?.service?.service_name || "Quality"}</span> Services For Every Need.</h1>
                        <p>Trusted experts delivering reliable service, transparent pricing, and customer-first support from consultation to completion.</p>
                        <div className="list">
                            <div className="chip"><i>✓</i><span>24/7 Support</span></div>
                            <div className="chip"><i>✓</i><span>Talk to Experts</span></div>
                           
                        </div>
                        <div className="actions">
                            <button className="cta">Consult Now</button>
                            <button className="cta secondary">Learn More</button>
                        </div>
                    </div>
                    <div className="visual">
                        <div className="circle"></div>
                        <div className="shape-deco"></div>
                        <div className="portrait"><img src={get_data?.featured_image || "https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=900&auto=format&fit=crop"} alt="portrait" /></div>
                        <div className="shape-deco2"></div>
                    </div>
                </div>
            </header>

            <main>
                <section className="section" id="intro">
                    <div className="container">
                        <div className="grid-hero">
                            <div className="mosaic">
                                {mosaicImgs.slice(0,4).map((src, i) => (
                                    <img key={i} src={src} alt={`m${i+1}`} />
                                ))}
                            </div>
                            <div className="info-card">
                                <h3>Trusted <span className="accent">{get_data?.service_name || get_data?.service?.service_name || "Service"}</span> Solutions, Delivered With Care</h3>
                                <p className="lead">From inquiry to completion, we provide dependable service, transparent pricing, and responsive support for every need.</p>
                                <div className="features">
                                    <div className="feature"><b>Fast Service</b><span className="lead">Quick scheduling and on‑time delivery.</span></div>
                                    <div className="feature"><b>Clear Pricing</b><span className="lead">Upfront quotes with no hidden costs.</span></div>
                                    <div className="feature"><b>Verified Professionals</b><span className="lead">Skilled experts and quality assurance.</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="section" id="services">
                    <div className="container">
                        <h2>Available Services</h2>
                        <p className="lead">Browse offerings with transparent pricing and quality delivery.</p>
                        {ps.length ? (
                            <OwlCarousel
                                className="owl-theme"
                                nav
                                navText={["‹","›"]}
                                loop={ps.length > 3}
                                margin={18}
                                autoplay
                                dots
                                responsive={{
                                    0: { items: 1 },
                                    640: { items: 2 },
                                    992: { items: 3 }
                                }}
                            >
                                {ps.map((item, idx) => (
                                    <div key={idx} className="s-card">
                                        <div className="s-icon">{(item?.service_name || 'SV').slice(0,2).toUpperCase()}</div>
                                        <div className="s-title">{item?.service_name}</div>
                                        <div className="s-desc">{item?.description || 'Professional service with care and reliability.'}</div>
                                        {cardImage(item) ? (
                                            <div className="s-thumb">
                                                {item?.price ? (<div className="s-badge">₹{item.price}</div>) : null}
                                                <img src={cardImage(item)} alt={item?.service_name || 'service'} />
                                            </div>
                                        ) : null}
                                        <div className="s-actions">
                                            <a className="cta" href={phone ? `tel:${phone}` : '/contact-us'}>Call Now</a>
                                            <a className="cta secondary" href="/contact-us">Enquire Now</a>
                                        </div>
                                    </div>
                                ))}
                            </OwlCarousel>
                        ) : (
                            <div className="lead">No services listed yet.</div>
                        )}
                    </div>
                </section>

                {/* <section className="section" id="pricing">
                    <div className="container">
                        <h2>We Offer Great Affordable Premium Prices.</h2>
                        <div className="pricing">
                            <div className="price-card"><img src="https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=1200&auto=format&fit=crop" alt="p1" /><div className="lead" style={{ marginTop: "10px" }}>Starter and Growth plans covering essentials.</div></div>
                            <div className="price-card"><img src="https://images.unsplash.com/photo-1529333166437-7750a6dd5a70?q=80&w=1200&auto=format&fit=crop" alt="p2" /><div className="lead" style={{ marginTop: "10px" }}>Enterprise support and custom integrations.</div></div>
                        </div>
                    </div>
                </section> */}

                <section className="section" id="testimonials">
                    <div className="container">
                        <h2>Client’s Testimonials</h2>
                        <div className="testimonial">
                            <input type="radio" id="t-1" name="t" defaultChecked />
                            <input type="radio" id="t-2" name="t" />
                            <input type="radio" id="t-3" name="t" />
                            <div className="t-slider">
                                <div className="t-track">
                                    {reviews.length ? (
                                        reviews.map((r, idx) => (
                                            <div key={idx} className="t-card">
                                                <div className="t-head">
                                                    <div className="avatar" style={{width:'54px',height:'54px',borderRadius:'50%',display:'grid',placeItems:'center',background:'#eef2ff',color:'#0f1b2a',fontWeight:700}}>{initials(r.first_name)}</div>
                                                    <div>
                                                        <div className="t-name">{r.first_name}</div>
                                                        <div className="t-role">{(r.date || '').slice(0,10)}</div>
                                                    </div>
                                                </div>
                                                <div className="stars">{stars(r.ratings)}</div>
                                                <p className="quote">{r.comments}</p>
                                            </div>
                                        ))
                                    ) : (
                                        <>
                                            <div className="t-card">
                                                <div className="t-head">
                                                    <div className="avatar" style={{width:'54px',height:'54px',borderRadius:'50%',display:'grid',placeItems:'center',background:'#eef2ff',color:'#0f1b2a',fontWeight:700}}>JL</div>
                                                    <div>
                                                        <div className="t-name">Jordan Lee</div>
                                                        <div className="t-role">Founder, Flux</div>
                                                    </div>
                                                </div>
                                                <div className="stars">★★★★★</div>
                                                <p className="quote">Reliep’s team built a polished product with measurable performance improvements and a design system our team loves.</p>
                                            </div>
                                            <div className="t-card">
                                                <div className="t-head">
                                                    <div className="avatar" style={{width:'54px',height:'54px',borderRadius:'50%',display:'grid',placeItems:'center',background:'#eef2ff',color:'#0f1b2a',fontWeight:700}}>AB</div>
                                                    <div>
                                                        <div className="t-name">Amelia Brown</div>
                                                        <div className="t-role">COO, North</div>
                                                    </div>
                                                </div>
                                                <div className="stars">★★★★★</div>
                                                <p className="quote">Clear communication, reliable delivery and thoughtful design. The handoff to our internal team was seamless.</p>
                                            </div>
                                            <div className="t-card">
                                                <div className="t-head">
                                                    <div className="avatar" style={{width:'54px',height:'54px',borderRadius:'50%',display:'grid',placeItems:'center',background:'#eef2ff',color:'#0f1b2a',fontWeight:700}}>DA</div>
                                                    <div>
                                                        <div className="t-name">Diego Alvarez</div>
                                                        <div className="t-role">Head of Marketing, Luma</div>
                                                    </div>
                                                </div>
                                                <div className="stars">★★★★★</div>
                                                <p className="quote">Performance tuning and SEO work brought measurable traffic growth while keeping the UX pristine.</p>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                            <div className="t-arrows">
                                <div className="arrow a-1">
                                    <label htmlFor="t-3" className="btn">‹</label>
                                    <label htmlFor="t-2" className="btn">›</label>
                                </div>
                                <div className="arrow a-2">
                                    <label htmlFor="t-1" className="btn">‹</label>
                                    <label htmlFor="t-3" className="btn">›</label>
                                </div>
                                <div className="arrow a-3">
                                    <label htmlFor="t-2" className="btn">‹</label>
                                    <label htmlFor="t-1" className="btn">›</label>
                                </div>
                            </div>
                            <div className="t-controls">
                                <label htmlFor="t-1"></label>
                                <label htmlFor="t-2"></label>
                                <label htmlFor="t-3"></label>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="section" id="highlights">
                    <div className="container stats">
                        <span className="m-shape one"></span>
                        <span className="m-shape two"></span>
                        <span className="m-shape three"></span>
                        <div className="stat">
                            <div className="m-icon blue">QS</div>
                            <b>Quality Service</b>
                            <div>Experienced professionals and careful delivery</div>
                        </div>
                        <div className="stat">
                            <div className="m-icon green">SS</div>
                            <b>Safe & Secure</b>
                            <div>Trusted partner with customer-first support</div>
                        </div>
                        <div className="stat">
                            <div className="m-icon yellow">FS</div>
                            <b>Flexible Scheduling</b>
                            <div>Book when it works best for you</div>
                        </div>
                        <div className="stat">
                            <div className="m-icon pink">EP</div>
                            <b>Easy Payments</b>
                            <div>{get_data?.payment_mode || 'Online, Offline'}</div>
                        </div>
                    </div>
                </section>

                {/* <section className="section contact" id="contact">
                    <div className="container form-wrap">
                        <h2>Let’s Stay Connected</h2>
                        <p className="lead">Share a few details and we’ll follow up with options tailored to your goals.</p>
                        <div className="form">
                            <div>
                                <label>Full Name</label>
                                <input type="text" placeholder="John Doe" />
                            </div>
                            <div>
                                <label>Email</label>
                                <input type="email" placeholder="john@example.com" />
                            </div>
                            <div>
                                <label>Phone Number</label>
                                <input type="tel" placeholder="(000) 000-0000" />
                            </div>
                            <div>
                                <label>Select Service</label>
                                <select><option>UI/UX Design</option><option>Web Development</option><option>App Development</option><option>SEO</option></select>
                            </div>
                            <div className="row">
                                <div>
                                    <label>Company</label>
                                    <input type="text" placeholder="Company Inc." />
                                </div>
                                <div>
                                    <label>Budget</label>
                                    <select><option>$5k–$10k</option><option>$10k–$25k</option><option>$25k+</option></select>
                                </div>
                            </div>
                            <div className="row">
                                <div style={{ gridColumn: "1 / -1" }}>
                                    <label>Message</label>
                                    <textarea placeholder="Write your message"></textarea>
                                </div>
                            </div>
                            <div className="actions">
                                <button className="cta">Send Message</button>
                                <button className="cta secondary">Schedule Call</button>
                            </div>
                        </div>
                    </div>
                </section> */}

                <section className="container cta-band">
                    <div>
                        <div style={{ fontSize: "26px", fontWeight: 700 }}>Trusted By Thousands For Quality, Professional Service.</div>
                        <div style={{ opacity: ".9", marginTop: "6px" }}>Reliable experts, transparent pricing, and customer‑first support.</div>
                    </div>
                    <button className="cta secondary" style={{ background: "#fff", color: "#1f2636", border: "none" }}>Get Started</button>
                </section>
            </main>

            <footer>
                <div className="container footer-top">
                    <div>
                        <div className="brand"><img src="https://reliep.com/services-img/images/logo.png" alt="logo" style={{width:"100px"}}></img></div>
                        <p style={{ marginTop: "10px", color: "var(--muted)" }}>We connect you with trusted professionals to handle your tasks quickly and affordably. Whether it's a small fix or a larger job, booking is simple, and help is just a click away.</p>
                    </div>
                    <div style={{ textAlign: "center" }}>
                        <div style={{ fontWeight: 600 }}>Links</div>
                        <div style={{ marginTop: "10px", color: "var(--muted)" }}>Home • Services • Portfolio • Testimonials • Contact</div>
                    </div>
                    <div>
                        <div style={{ fontWeight: 600 }}>Newsletter</div>
                        <div className="newsletter" style={{ marginTop: "10px" }}>
                            <input type="email" placeholder="your@email.com" />
                            <button className="cta">Join</button>
                        </div>
                    </div>
                </div>
                <div className="container footer-bottom">
                    <div>© 2025 Reliep</div>
                    <div className="dots"><div className="dot"></div><div className="dot"></div><div className="dot"></div><div className="dot"></div></div>
                    <div>Privacy • Terms</div>
                </div>
            </footer>
        </>
    )
}
export default Thirdtheme